"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CART_STATE = void 0;
const CART_STATE = exports.CART_STATE = {
  BEFORE_ADD_TO_CART: 'beforeAddToCart',
  ADD_TO_CART_SUCCESS: 'addToCartSuccess',
  ADD_TO_CART_FAILURE: 'addToCartFailure',
  ADD_TO_CART_UNAVAILABLE: 'addToCartUnavailable',
  BEFORE_REMOVE_FROM_CART: 'beforeRemoveFromCart',
  REMOVE_FROM_CART_SUCCESS: 'removeFromCartSuccess',
  REMOVE_FROM_CART_FAILURE: 'removeFromCartFailure'
};